module.exports = __webpack_public_path__ + "static/media/event-2.70e693c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/img/event-2.jpg
// module id = 121
// module chunks = 1